// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc */

/**
 * If you update this file, you will also need to update FaqTracking.java and FaqTrackingData.java.
 */

export type FaqTrackingData = {|
  /** The servlet name of the page that renders the FAQ markup */
  servlet?: string,
  /** The URL parameters of the page that renders the FAQ markup */
  urlParameters?: { [string]: string },
  /** The template id of the Q&A */
  templateId?: number,
  /** The position where the Q&A is rendered. For example 0 for the first slot */
  questionPosition?: number,
|};

const FAQ_MCID = '63287';
const FAQ_TRACKING_HOST_SERVLET = 'faqts';
const FAQ_TRACKING_HOST_URL_PARAMETERS = 'faqtup';
const FAQ_TRACKING_TEMPLATE_ID = 'faqtt';
const FAQ_TRACKING_QUESTION_POSITION = 'faqtqr';
const PARAMS_DELIMITER = ';';
const KEY_VALUE_DELIMITER = ':';

/**
 * Serialize a map of url parameters to a string in the format of key1:val1;key2:val2;k3:val3...
 * @param urlParams an object map of url parameters
 */
const urlParamsToString = (urlParams: { [string]: string }): string =>
  Object.entries(urlParams)
    // $FlowFixMe kv[1] is always a string
    .map(kv => `${kv[0]}${KEY_VALUE_DELIMITER}${kv[1]}`)
    .join(PARAMS_DELIMITER);

/**
 * Build a FAQ json ld markup link with extra tracking info.
 *
 * Collect data we are interested in tracking for FAQ and serialize it to a json string.
 *
 * @param originalUrl the original URL without tracking info.
 * @param urlFragment any URL fragment we want to append to the URL.
 * @param inputData the tracking data
 * @returns a URL with tracking info.
 */
const buildUrlWithTracking = (
  originalUrl: string,
  urlFragment?: ?string,
  inputData: FaqTrackingData,
): string => {
  let finalUrl = originalUrl;
  const searchParams = new URLSearchParams();

  // Add mcid
  searchParams.append('m', FAQ_MCID);

  // Add tracking data
  if (inputData.servlet) {
    searchParams.append(FAQ_TRACKING_HOST_SERVLET, inputData.servlet);
  }
  if (inputData.urlParameters) {
    searchParams.append(
      FAQ_TRACKING_HOST_URL_PARAMETERS,
      urlParamsToString(inputData.urlParameters),
    );
  }
  if (inputData.templateId !== undefined && inputData.templateId !== null) {
    searchParams.append(FAQ_TRACKING_TEMPLATE_ID, `${inputData.templateId}`);
  }
  if (inputData.questionPosition !== undefined && inputData.questionPosition !== null) {
    searchParams.append(FAQ_TRACKING_QUESTION_POSITION, `${inputData.questionPosition}`);
  }

  // Concat everything together.
  const queryString = searchParams.toString();
  finalUrl = `${finalUrl}?${queryString}`;
  if (urlFragment) {
    finalUrl = `${finalUrl}#${urlFragment}`;
  }

  return finalUrl;
};

export default buildUrlWithTracking;
